import React from 'react';
import { motion } from 'framer-motion';
// Updated and new icons for a better visual impression
import { FaBrain, FaCogs, FaProjectDiagram, FaChartBar } from 'react-icons/fa';
import { BsChatDotsFill, BsFillMicFill, BsGearFill, BsKanbanFill } from "react-icons/bs";

const Services = () => {
  // A list of the specific AI agents you build
  const agentTypes = [
    { icon: <BsChatDotsFill />, name: "Korisnička podrška" },
    { icon: <BsFillMicFill />, name: "Prodajni asistent" },
    { icon: <BsGearFill />, name: "Status porudžbine" },
    { icon: <BsKanbanFill />, name: "Česta pitanja (FAQ)" }
  ];

  // Services are now presented as steps in the process and their benefits
  const services = [
    {
      icon: <FaBrain className="text-4xl" />,
      title: "Analiza & Identifikacija",
      description: "Analiziramo tvoj inbox i identifikujemo gde gubiš prodaje. Naš cilj je da ti vratimo 40 radnih sati svakog meseca."
    },
    {
      icon: <FaProjectDiagram className="text-4xl" />,
      title: "Prodajni Scenariji",
      description: "Kreiramo plan komunikacije i prodajne scenarije koji zvuče prirodno, a konvertuju bolje od prosečnog agenta."
    },
    {
      icon: <FaCogs className="text-4xl" />,
      title: "Launch & 24/7 Monitoring",
      description: "Implementiramo, testiramo i pratimo svaku poruku. Tvoj shop radi i prodaje dok ti spavaš, bez greške."
    }
  ];

  const fadeIn = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: "easeInOut" }
  };

  return (
    <section id="ponuda" className="py-20 bg-gradient-to-br from-black via-gray-900 to-black border-t border-b border-gray-800">
      <div className="max-w-6xl mx-auto px-4">

        {/* 1. MAIN HEADING - Clear and direct */}
        <motion.div
          className="text-center mb-12"
          variants={fadeIn}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">Obećavamo 3 stvari.</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Ne prodajemo samo chatbota. Prodajemo sistem koji štedi tvoje vreme i povećava konverziju kroz brži odgovor i bolju konverzaciju.
          </p>
        </motion.div>

        {/* 2. NEW SECTION - "WHAT WE BUILD" */}
        <div className="mb-16">
          <h3 className="text-center text-2xl font-semibold text-blue-400 mb-8">Agenti koje pravimo za e-commerce</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {agentTypes.map((agent, index) => (
              <motion.div
                key={index}
                className="text-center bg-gray-900/50 p-4 rounded-lg border border-gray-800"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
              >
                <div className="flex justify-center text-3xl text-gray-300 mb-2">{agent.icon}</div>
                <p className="font-semibold text-gray-200">{agent.name}</p>
              </motion.div>
            ))}
          </div>
        </div>

        {/* 3. IMPROVED CARDS - Our process and value */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="bg-gradient-to-b from-gray-900 to-black border border-gray-800 rounded-lg p-6 text-center h-full flex flex-col hover:border-blue-500/50 transition-colors duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="flex justify-center text-blue-400 mb-5">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
              <p className="text-gray-400 flex-grow">{service.description}</p>
            </motion.div>
          ))}
        </div>


      </div>
    </section>
  );
};

export default Services;